import { render } from "./gzxx.vue?vue&type=template&id=47b1079c&scoped=true&ts=true"
import script from "./gzxx.vue?vue&type=script&lang=ts"
export * from "./gzxx.vue?vue&type=script&lang=ts"

import "./gzxx.vue?vue&type=style&index=0&id=47b1079c&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b1079c"]])

export default __exports__